<template>
  <div>
    <section class="section">
      <p v-if="'LT' === appLang"><strong>SAUGUS APSILANKYMAS SALONE</strong></p>
      <p v-else><strong>UMÓW SIĘ NA BEZPIECZNĄ WIZYTĘ</strong></p>
      <hr>
      <section v-if="'LT' === appLang" class="">
        <div class="field">
          <label class="label required">Jūsų vardas *</label>
          <div class="control">
            <input v-model="name" :class="{'is-danger': errors.name}" class="input" placeholder="Jūsų vardas"
                   type="text">
          </div>
        </div>
        <div class="field">
          <label class="label required">Jūsų pavardė *</label>
          <div class="control">
            <input v-model="surname" :class="{'is-danger': errors.surname}" class="input" placeholder="Jūsų pavardė"
                   type="text">
          </div>
        </div>
        <div class="field">
          <label class="label">Telefono numeris *</label>
          <div class="control">
            <input v-model="telephone" :class="{'is-danger': errors.telephone}" class="input"
                   placeholder="Telefono numeris"
                   type="number">
          </div>
        </div>
        <div class="field">
          <label class="label required">Jūsų el. pašto adresas *</label>
          <div class="control">
            <input v-model="email" :class="{'is-danger': errors.email}" class="input" placeholder="Jūsų el. pašto adresas"
                   type="email">
          </div>
        </div>
        <div class="field">
          <label class="label required">Pasirinkite apsilankymo tikslą</label>
          <div class="control">
            <select v-model="visitationReason" class="select">
              <option>Regos patikrinimas</option>
              <option>Akinių parinkimas</option>
              <option>Regos patikrinimas ir akinių parinkimas</option>
            </select>
          </div>
        </div>
        <div class="field">
          <label class="label required"> Nurodykite pageidaujamą datą
          </label>
          <div class="field">
            <p v-if="errors.dateError" class="help is-danger">Su jumis galime susisiekti nuo pat pirmos dienos
              rytoj</p>
            <div class="control">
              <datepicker v-model="date" :disabled-dates="state.disabledDates" :input-class="'input'" :language="lt"
                          monday-first></datepicker>
            </div>
          </div>
        </div>
      </section>

      <section v-else class="">
        <div class="field">
          <label class="label required">Twoje imię *</label>
          <div class="control">
            <input v-model="name" :class="{'is-danger': errors.name}" class="input" placeholder="Imię"
                   type="text">
          </div>
        </div>
        <div class="field">
          <label class="label required">Twoje nazwisko *</label>
          <div class="control">
            <input v-model="surname" :class="{'is-danger': errors.surname}" class="input" placeholder="Nazwisko"
                   type="text">
          </div>
        </div>
        <div class="field">
          <label class="label">Numer telefonu *</label>
          <div class="control">
            <input v-model="telephone" :class="{'is-danger': errors.telephone}" class="input"
                   placeholder="Numer telefonu"
                   type="number">
          </div>
        </div>
        <div class="field">
          <label class="label required">Twój adres e-mail *</label>
          <div class="control">
            <input v-model="email" :class="{'is-danger': errors.email}" class="input" placeholder="E-mail"
                   type="email">
          </div>
        </div>
        <div class="field">
          <label class="label required">Wybierz cel wizyty</label>
          <div class="control">
            <select v-model="visitationReason" class="select">
              <option>Badanie wzroku</option>
              <option>Dobór szkieł</option>
              <option>Badanie wzroku i dobór szkieł</option>
            </select>
          </div>
        </div>
        <div class="field">
          <label class="label required"> Podaj nam preferowaną datę
          </label>
          <div class="field">
            <p v-if="errors.dateError" class="help is-danger">Możemy skontaktowa się z Tobą od dnia
              jutrzejszego</p>
            <div class="control">
              <datepicker :input-class="'input'" :disabled-dates="state.disabledDates" :language="pl" v-model="date" monday-first></datepicker>
            </div>
          </div>
        </div>
      </section>
      <hr>
      <section class="">
        <div class="field ">
          <div class="field">
            <label class="checkbox required">
              <input v-model="serviceRegulations" type="checkbox"/>
              <span v-if="'LT' === appLang" :class="{'is-danger-checkbox': errors.serviceRegulations}">
                Pareiškiu, kad perskaičiau paslaugų <a :href="regulationUri" target="_blank">teikimo taisykles</a> ir patvirtinu jas, kad galėčiau susitarti dėl saugaus apsilankymo, kuris galimas išsiuntus užpildytą registracijos formą, esančią optikos salonų sąraše.*
              </span>
              <span v-else :class="{'is-danger-checkbox': errors.serviceRegulations}">
                Oświadczam, że zapoznałam/-em się z <a :href="regulationUri" target="_blank">Regulaminem świadczenia usług</a> i go akceptuję na potrzeby umówienia się na bezpieczną wizytę możliwe do zrealizowania po wysłaniu wypełnionego formularza dostępnego na lokalizatorze optyków. *
              </span>
            </label>
          </div>
        </div>
      </section>
      <hr>
      <section class="">
        <div class="field">
          <p v-if="'cnw' === appVariantName">Informujemy, że jako Grupa Essilor dokonujemy współadministrowania
            Pani/Pana danymi osobowymi w przesłanym formularzu rejestracyjnym dla celów związanych z zarządzaniem
            zgłoszeniem. Nie przetwarzamy Pani/Pana danych osobowych we własnych celach marketingowych. Informujemy, że
            niezależnym Administratorem Pani/Pana danych jest salon optyczny, w którym zostanie umówiona bezpieczna
            wizyta. Więcej informacji, w tym o przysługujących Pani/Panu prawach oraz o zasadniczej treści uzgodnień
            jakie poczyniliśmy w ramach współadministrowania Pani/Pana danymi osobowymi znajduje się w naszej <a
                href="https://czasnawzrok.pl/wp-content/uploads/2020/05/polityka-prywatnosci.pdf" target="_blank">Polityce
              prywatności</a>. W skład Grupy Essilor wchodzą: Essilor Polonia Sp. z o.o., JZO S.A. oraz JAI KUDO Polska
            Sp. z
            o.o.</p>
          <p v-if="'nikon' === appVariantName && 'PL' === appLang">Administratorem danych osobowych jest JZO S. A. z siedzibą w Jeleniej
            Górze 58-500, ul. Ludwika Waryńskiego 12. Dane osobowe będą przetwarzane dla celów związanych z zarządzaniem
            zgłoszeniem. Nie przetwarzamy Pani/Pana danych osobowych we własnych celach marketingowych. Informujemy, że
            niezależnym Administratorem Pani/Pana danych jest salon optyczny, w którym zostanie umówiona bezpieczna
            wizyta. Więcej informacji na temat przetwarzania danych osobowych, w tym o przysługujących Państwu prawach
            na gruncie RODO znajduje się w <a href="https://www.nikon-lenswear.pl/privacy-policy/" target="_blank">Polityce
              prywatności</a>.</p>
          <p v-if="'jzo' === appVariantName">Administratorem danych osobowych jest JZO S. A. z siedzibą w Jeleniej Górze
            58-500, ul. Ludwika Waryńskiego 12. Dane osobowe będą przetwarzane dla celów związanych z zarządzaniem
            zgłoszeniem. Nie przetwarzamy Pani/Pana danych osobowych we własnych celach marketingowych. Informujemy, że
            niezależnym Administratorem Pani/Pana danych jest salon optyczny, w którym zostanie umówiona bezpieczna
            wizyta. Więcej informacji na temat przetwarzania danych osobowych, w tym o przysługujących Państwu prawach
            na gruncie RODO znajduje się w <a href="https://www.jzo.com.pl/polityka-prywatnosci/" target="_blank">Polityce
              prywatności</a>.</p>
          <p v-if="'varilux' === appVariantName">Administratorem danych osobowych jest Essilor Polonia Sp. z o.o. z
            siedzibą w Warszawie 03-236, ul. Annopol 17. Dane osobowe będą przetwarzane dla celów związanych z
            zarządzaniem zgłoszeniem. Nie przetwarzamy Pani/Pana danych osobowych we własnych celach marketingowych.
            Informujemy, że niezależnym Administratorem Pani/Pana danych jest salon optyczny, w którym zostanie umówiona
            bezpieczna wizyta. Więcej informacji na temat przetwarzania danych osobowych, w tym o przysługujących
            Państwu prawach na gruncie RODO znajduje się w <a href="https://www.essilor.pl/polityka-prywatnosci"
                                                              target="_blank">Polityce prywatności</a>.</p>
          <p v-if="'jai-kudo' === appVariantName">Administratorem danych osobowych jest JAI KUDO POLSKA SP. Z. O. O. z
            siedzibą w Poznaniu 60-418, ul. Chodzieska 15. Dane osobowe będą przetwarzane dla celów związanych z
            zarządzaniem zgłoszeniem. Nie przetwarzamy Pani/Pana danych osobowych we własnych celach marketingowych.
            Informujemy, że niezależnym Administratorem Pani/Pana danych jest salon optyczny, w którym zostanie umówiona
            bezpieczna wizyta. Więcej informacji na temat przetwarzania danych osobowych, w tym o przysługujących
            Państwu prawach na gruncie RODO znajduje się w <a href="https://jaikudo.pl/polityka-cookies/"
                                                              target="_blank">Polityce prywatności</a>.</p>
          <p v-if="'LT' === appLang">Asmens duomenų valdytojas yra UAB JZO optika, kurios būstinė yra Vilnius, Savanorių pr. 187, į.k. 111807380. Asmens duomenys bus tvarkomi prašymo tvarkymo tikslais. Netvarkome jūsų asmens duomenų savo rinkodaros tikslais. Informuojame, kad nepriklausomas jūsų asmens duomenų valdytojas yra optikos salonas, kuriame bus susitarta dėl saugaus apsilankymo. Daugiau informacijos apie asmens duomenų tvarkymą, įskaitant jūsų teises pagal BDAR, rasite <a href="https://nikon-lenswear.lt/privatumo-politika/" target="_blank">privatumo politikoje</a>.</p>
          <br/>
          <p v-if="'LT' === appLang">*privaloma</p>
          <p v-else>*obowiązkowe</p>
        </div>
      </section>
      <hr>
      <article v-show="this.formErrors" class="message is-danger">
        <div v-if="'LT' === appLang" class="message-header">
          Formoje yra klaidų, kurias reikia ištaisyti. Išsamią informaciją galite rasti šalia kiekvieno neteisingai užpildyto lauko.
        </div>
        <div v-else class="message-header">
          Formularz zawiera błędy, które należy poprawić. Szczegóły znajdziesz przy każdym z błędnie wypełnionych pól.
        </div>
      </article>
      <div v-if="'LT' === appLang" class="locator__place-extended-download ">
        <h3 class="locator__place-extended-title"><a class="btn" href="#" @click="submitForm()">NORIU SUSITARTI DĖL SAUGAUS APSILANKYMO OPTIKOS SALONE</a></h3>
        <p>Pasirinktas optikos salonas susisieks su jumis kaip galima greičiau, kad patvirtintų jūsų apsilankymą.</p>
      </div>
      <div v-else class="locator__place-extended-download ">
        <h3 class="locator__place-extended-title"><a class="btn" href="#" @click="submitForm()">UMÓW MNIE NA BEZPIECZNĄ
          WIZYTĘ W SALONIE OPTYCZNYM</a></h3>
        <p>Wybrany salon optyczny skontaktuje się z Tobą najszybciej jak tylko będzie to możliwe w celu potwierdzenia
          wizyty.</p>
      </div>

    </section>
  </div>
</template>

<script>
  import Datepicker from 'vuejs-datepicker';
  import {pl, lt} from 'vuejs-datepicker/dist/locale'
  import axios from 'axios'

export default {
  name: "safe-appointment-form",
  props: ['institutionId', 'institutionName', 'city'],
  components: {
    Datepicker,
  },
  data() {
    return {
      state: {
        disabledDates: {
          to: new Date(),
          days: [6, 0]
        }
      },
      pl: {pl, lt}[this.$appLang.toLowerCase()],
      videoContact: false,
      telephoneContact: false,
      facebookAddress: '',
      whatsapp: '',
      telephone: '',
      date: new Date(),
      name: '',
      surname: '',
      calendar: '',
      hour_range: '11-14',
      leadType: 'safe-appointment',
      email: '',
      visitationReason: 'Badanie wzroku',
      serviceRegulations: false,
      mailMarketing: false,
      smsMarketing: false,
      telephoneMarketing: false,
      webCommunicatorsMarketing: false,
      formErrors: false,
      errors: {
        visitationReason: false,
        serviceRegulations: false,
        videoContact: false,
        telephoneContact: false,
        contactMethod: false,
        name: false,
        surname: false,
        facebookAddress: false,
        telephone: false,
        whatsapp: false,
        email: false,
        dateError: false
      }
    };
  }, mounted() {

    const tomorrow = new Date(this.date)
    tomorrow.setDate(tomorrow.getDate() + 1)
    this.date = tomorrow
  },
  computed: {
    appLang() {
      return this.$appLang;
    },
    appVariantName() {
      return this.$siteVariantName;
    },
    regulationUri() {
      switch (this.$siteVariantName) {
        case 'cnw':
          return 'https://czasnawzrok.pl/wp-content/uploads/2020/11/regulamin-swiadczenia-uslug-droga-elektroniczna-umow-na-wizyte-cnw.pdf';
        case 'varilux':
          return 'https://www.varilux.pl/upload/2020/11/regulamin-swiadczenia-uslug-droga-elektroniczna-umow-na-wizyte-essilor.pdf';
        case 'jai-kudo':
          return 'https://sklep.jaikudo.pl/pobierz/Regulamin-%20umow.pdf';
        case 'jzo':
          return 'https://www.jzo.com.pl/wp-content/uploads/regulamin-swiadczenia-uslug-droga-elektroniczna-umow-sie-na-wizyte-jzo.pdf';
        case 'nikon':
          if ('LT' === this.$appLang) {
            return 'https://nikon-lenswear.lt/wp-content/uploads/2021/03/ELEKTRONINIU_PASLAUGU.pdf';
          } else {
            return 'https://www.nikon-lenswear.pl/wp-content/uploads/2020/11/regulamin-swiadczenia-uslug-droga-elektroniczna_umow_sie_na_wizyte_nikon.pdf';
          }
      }
    }
  },
  methods: {
    checkAgreements() {
      this.mailMarketing = true;
      this.smsMarketing = true;
      this.telephoneMarketing = true;
      this.webCommunicatorsMarketing = true;
    },
    onAppointmentSubmit() {
      parent.dataLayer.push({
        nazwamiasta: this.city,
        nazwasalonu: this.institutionName,
        event: "wyslanie-formularza-klik"
      });
    },
    onAppointmentSuccessSubmit() {
      parent.dataLayer.push({
        nazwamiasta: this.city,
        nazwasalonu: this.institutionName,
        event: "wyslanie-formularza-poprawne"
      });
    },
    submitForm() {
      if (false === this.validate()) {
        return false;
      }

      let payload = {
        'videoContact': this.videoContact,
        'telephoneContact': this.telephoneContact,
        'facebookAddress': this.facebookAddress,
        'telephone': this.telephone,
        'whatsapp': this.whatsapp,
        'name': this.name,
        'surname': this.surname,
        'visitationReason': this.visitationReason,
        'date': this.date,
        'leadType': this.leadType,
        'email': this.email,
        'serviceRegulations': this.serviceRegulations,
        'mailMarketing': this.mailMarketing,
        'smsMarketing': this.smsMarketing,
        'telephoneMarketing': this.telephoneMarketing,
        'webCommunicatorsMarketing': this.webCommunicatorsMarketing,
        'institution': this.institutionId,
        'lang': this.$appLang.toLowerCase()
      }
      
      
      let locatorSlug = this.$siteVariantName;
      var that = this;

      that.onAppointmentSubmit();

      axios.post(`/leads/${locatorSlug}/save`, payload)
          .then(function (response) {
            that.$emit("form-result", true);
            that.onAppointmentSuccessSubmit();
          })
          .catch(function (error) {
            error = error.response.data;
            console.log(error)
            if (error.hasOwnProperty('errors')) {
              for (let errors in error.errors.children) {
                let child = error.errors.children[errors];
                if (!child.hasOwnProperty('errors')) {
                  continue;
                }
                that.setError(errors);
                return;
              }

            }
            that.$emit("form-result", false);
          });
    },
    setError(key) {
      if (this.errors.hasOwnProperty(key)) {
        this.errors[key] = true
      }
    },
    validate() {
      this.formErrors = false;
      for (let error in this.errors) {
        this.errors[error] = false
      }

      if (this.serviceRegulations == false) {
        this.errors.serviceRegulations = true
      }

      if (this.telephone == "") {
        this.errors.telephone = true
      }


      let today = new Date();
      if (this.date < today) {
        this.errors.dateError = true
      }


      let toValidate = [
        'date', 'name', 'email', 'surname'
      ];
      let that = this;


      toValidate.forEach((el) => {
        if ("" == that[el]) {
          that.errors[el] = true
        }
      });

      for (let error in this.errors) {
        if (this.errors[error]) {
          this.formErrors = true
          return false;
        }
      }

      return true;

    }
  },
}
</script>

<style>
.vdp-datepicker__calendar .up {
  transform: rotate(0deg) !important;
  -webkit-transform: rotate(0deg) !important;
}
</style>
